(function () {
  if (window.__DLFS) return;  // evitar doble init
  window.__DLFS = true;

  const DRAWER_SEL = '#MinimogCartDrawer';
  const WRAP_SEL = '#dl-free-ship';

  function clp(cents) { return (cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' }); }
  async function getCart() { return (await fetch('/cart.js', { credentials: 'same-origin' })).json(); }

  function ensureMarkup() {
    const wrap = document.querySelector(WRAP_SEL);
    if (!wrap || wrap.__built) return;
    wrap.innerHTML = `
    <div class="shipping-bar-container">
        <p class="shipping-message"></p>
        <div class="progress-track">
            <div class="progress-fill">
                <div class="progress-icon">
                    <svg fill="currentColor" width="20" height="20" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                        <path d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
    <style>
        .shipping-bar-container {
            width: 100%;
            margin-bottom: 20px;
        }
        .shipping-message {
            font-family: inherit;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 500;
            color: #111;
            text-align: left;
        }
        .progress-track {
            background-color: #f3f4f6;
            height: 10px;
            width: 100%;
            border-radius: 99px;
            position: relative;
            overflow: visible;
        }
        .progress-fill {
            background-color: #000;
            height: 100%;
            width: 0%;
            border-radius: 99px;
            transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            min-width: 10px;
        }
        .progress-icon {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate(50%, -50%);
            width: 32px;
            height: 32px;
            background: #fff;
            border: 2px solid #000;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
            z-index: 2;
        }
        .progress-icon.iconicion {
            background: #000;
            color: #fff;
            box-shadow: 0 0 10px rgba(0,0,0,0.3);
        }
    </style>
  `;
    wrap.__built = true;
  }

  async function updateBar() {
    const wrap = document.querySelector(WRAP_SEL);
    if (!wrap) return;
    ensureMarkup();

    const THRESHOLD = Number(wrap.dataset.threshold || 80000) * 100; // a centavos
    const msg = wrap.querySelector('.shipping-message');
    const prog = wrap.querySelector('.progress-fill');
    const icon = wrap.querySelector('.progress-icon');

    try {
      const cart = await getCart();
      const total = cart.total_price || 0;
      const left = Math.max(THRESHOLD - total, 0);
      const pct = Math.max(0, Math.min(total / THRESHOLD, 1)) * 100; // clamp

      if (msg) {
        if (left > 0) {
          msg.innerHTML = `Te faltan <strong>${clp(left)}</strong> para completar el envío gratis!`;
          msg.style.color = '#111';
        } else {
          msg.textContent = '¡Felicidades! Tienes envío gratis.';
          msg.style.color = '#000';
        }
      }

      if (prog) prog.style.width = pct + '%';
      // Icon moves automatically because it is nested in progress-fill

      if (icon) icon.classList.toggle('iconicion', left <= 0);

    } catch (e) { /* silencioso */ }
  }


  // ---- Triggers para actualizar ----
  // 1) Eventos comunes
  ['minimog:cart:updated', 'minimog:cart:change', 'cart:updated', 'cart:change', 'ajaxProduct:added', 'ajaxProduct:removed']
    .forEach(ev => document.addEventListener(ev, updateBar));

  // 2) Parchear fetch y XHR para capturar /cart/*.js
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
    const isCart = url && /\/cart\/(add|change|update|clear)\.js/.test(url);
    return _fetch.apply(this, args).then(res => { if (isCart) setTimeout(updateBar, 0); return res; });
  };

  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__dlfsCart = typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js/.test(url);
    return _open.apply(this, arguments);
  };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__dlfsCart) this.addEventListener('loadend', () => setTimeout(updateBar, 0));
    return _send.apply(this, arguments);
  };

  // 3) Observer del drawer (por si no hay eventos)
  const connectObserver = () => {
    const body = document.querySelector(`${DRAWER_SEL} .m-cart-drawer__body`);
    if (!body) return;
    new MutationObserver(() => updateBar()).observe(body, { childList: true, subtree: true });
  };
  connectObserver();

  // 4) Pequeño polling mientras el drawer esté en el DOM (ultra robusto)
  setInterval(updateBar, 1200);

  // Inicial
  document.addEventListener('DOMContentLoaded', updateBar);
})();
